import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Button,
  IconButton,
  Drawer,
  Link,
  MenuItem,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import EmailIcon from '@material-ui/icons/Email';
import Logo from '../Images/varmatie_logo.png';
import circle247 from '../Images/24_7.svg';

const headersData = [
  {
    label: 'Meistä',
    href: '/meista',
  },
  // {
  //   label: 'Vuokraus',
  //   href: '/vuokraus',
  // },
  {
    label: 'Liikennejärjestelyt',
    href: '/liikennejarjestelyt',
  },
  {
    label: 'Ota yhteyttä',
    href: '/yhteys',
  },
];

const useStyles = makeStyles(() => ({
  header: {
    position: 'relative',
    backgroundColor: '#0f1620',
    paddingRight: '100px',
    paddingLeft: '100px',
    '@media (max-width: 1024px)': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  logo: {
    fontFamily: 'Work Sans, sans-serif',
    fontWeight: 600,
    color: '#FFFEFE',
    textAlign: 'left',
  },
  menuButton: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 700,
    size: '18px',
    marginLeft: '38px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  drawerContainer: {
    padding: '20px 30px',
  },
}));

export default function Header() {
  const {
    header, logo, menuButton, toolbar, drawerContainer,
  } = useStyles();

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  const { mobileView, drawerOpen } = state;

  useEffect(() => {
    const setResponsiveness = () => (window.innerWidth < 900
      ? setState((prevState) => ({ ...prevState, mobileView: true }))
      : setState((prevState) => ({ ...prevState, mobileView: false })));

    setResponsiveness();

    window.addEventListener('resize', () => setResponsiveness());
  }, []);

  const varmatieLogo = (
    <Typography variant="h6" component="h1" className={logo}>
      Varmatie
    </Typography>
  );

  const getMenuButtons = () => headersData.map(({ label, href }) => (
    <Button
      {...{
        key: label,
        color: 'inherit',
        to: href,
        component: RouterLink,
        className: menuButton,
      }}
    >
      {label}
    </Button>
  ));

  const displayDesktop = () => (
    <Toolbar className={toolbar}>
      <div>
      <a href="https://varmatie.com"><img alt="" src={Logo} style={{ width: '120px' }} /></a>
      <Typography style={{fontFamily: 'Open Sans'}}>Liikennejärjestelyt</Typography>
      </div>
      <div>{getMenuButtons()}</div>
      <div>
        <a href="https://www.facebook.com/varmatie">
          <FacebookIcon style={{ color: 'white', fontSize: '35' }} />
        </a>
        {/* <InstagramIcon style={{ color: 'white', fontSize: '35', paddingTop: '0.1em' }} /> */}
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img style={{ width: '70px' }} alt="" src={circle247} />
        <div style={{ paddingLeft: '1em' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <PhoneEnabledIcon style={{ color: '#e61d15', fontSize: '35' }} />
            <a href="tel:040 052 1198"><Typography style={{ display: 'inline', color: '#fff200', paddingLeft: '0.3em' }}>040 052 1198</Typography></a>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <EmailIcon style={{ color: '#e61d15', fontSize: '35' }} />
            <a href="mailto:info@varmatie.com"><Typography style={{ display: 'inline', color: '#fff200', paddingLeft: '0.3em' }}>info@varmatie.com</Typography></a>
          </div>
        </div>
      </div>
    </Toolbar>
  );

  const displayMobile = () => {
    const handleDrawerOpen = () => setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () => setState((prevState) => ({ ...prevState, drawerOpen: false }));

    const getDrawerChoices = () => headersData.map(({ label, href }) => (
      <Link
        {...{
          component: RouterLink,
          to: href,
          color: 'inherit',
          style: { textDecoration: 'none' },
          key: label,
        }}
      >
        <MenuItem>{label}</MenuItem>
      </Link>
    ));

    return (
      <Toolbar>
        <IconButton
          {...{
            edge: 'start',
            color: 'inherit',
            'aria-label': 'menu',
            'aria-haspopup': 'true',
            onClick: handleDrawerOpen,
          }}
        >
          <MenuIcon />
        </IconButton>

        <Drawer
          {...{
            anchor: 'left',
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <div className={drawerContainer}>{getDrawerChoices()}</div>
        </Drawer>

        <div>{varmatieLogo}</div>
      </Toolbar>
    );
  };

  return (
    <header>
      <AppBar className={header}>
        {mobileView ? displayMobile() : displayDesktop()}
      </AppBar>
    </header>
  );
}
